import * as React from 'react';
import {Backdrop, CircularProgress} from '@mui/material';

type FullScreenLoaderProps = {
  open: boolean;
  text?: React.ReactNode;
  blur?: boolean;
  zIndex?: number;
  spinnerSize?: number;
  thickness?: number;
  className?: string;
};

export default function FullScreenLoader({
  open,
  text,
  blur = true,
  zIndex,
  spinnerSize = 56,
  thickness = 4,
  className,
}: FullScreenLoaderProps) {
  return (
    <Backdrop
      open={open}
      sx={theme => ({
        color: '#fff',
        zIndex: zIndex ?? theme.zIndex.modal + 1,
        backdropFilter: blur ? 'blur(2px)' : 'none',
        backgroundColor: 'rgba(0,0,0,0.35)',
      })}>
      <div className={`flex flex-col items-center gap-4 ${className ?? ''}`}>
        <CircularProgress size={spinnerSize} thickness={thickness} />
        {text ? <p className="m-0 text-white/90 text-sm">{text}</p> : null}
      </div>
    </Backdrop>
  );
}
